"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Generate image sizes

var generateSizes = function generateSizes(maxWidth) {
  // []
  if (maxWidth <= 350) {
    // We want srcset to be empty if the size is below 350. We will just
    // fallback to the src. This means that maxWidth becomes the images
    // only size.
    return [];
  } // [max, 80%]


  if (maxWidth <= 500) {
    return [maxWidth, Math.round(0.8 * maxWidth)];
  } // [max, 80%, 60%]


  if (maxWidth <= 700) {
    return [maxWidth, Math.round(0.8 * maxWidth), Math.round(0.6 * maxWidth)];
  } // [max, 80%, 60%, 40%]


  if (maxWidth <= 900) {
    return [maxWidth, Math.round(0.8 * maxWidth), Math.round(0.6 * maxWidth), Math.round(0.4 * maxWidth)];
  } // [max, 80%, 60%, 450, 350]


  return [maxWidth, Math.round(0.8 * maxWidth), Math.round(0.6 * maxWidth), 450, 350];
}; // Filter image sizes bellow 350 px


var filterSmallSizes = function filterSmallSizes(sizes) {
  return sizes.filter(function (size) {
    return size >= 350;
  });
};

var generateImageSizes = function generateImageSizes(maxWidth) {
  return filterSmallSizes(generateSizes(maxWidth));
};

var _default = generateImageSizes;
exports.default = _default;